

export const SubmitPickupComp=(
    <p>Submit form pickup components pane</p>
)